import { Flex, Heading, Text } from '@ox-technologies/ui';
import { useTranslation } from 'react-i18next';

const ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="col" gap={4} className="mt-6">
      <Heading as="h2" level={2}>
        {t('ErrorBoundary.Heading')}
      </Heading>
      <Text size="lg">{t('ErrorBoundary.Info')}</Text>
    </Flex>
  );
};

export default ErrorFallback;
